var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protocol-wrap"},[_c('h1',[_vm._v("订单协议")]),_c('div',{staticClass:"protocol-content"},[_vm._m(0),_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-wrap"},[_c('p',[_vm._v("1、处理期间，请拉黑或不与消费者联系、不对评价回复或解释（已回复的不影响处理）；")]),_c('p',[_vm._v("2、处理周期为五天，期限内撤单须扣除该订单付款金额50%违约金，五天期限后可正常申请退款 ；")]),_c('p',[_vm._v("3、五天处理期限内，不自行或交由他人处理，期限内解决的订单，都代表任务完成，应当收取费用 。")])])
}]

export { render, staticRenderFns }